import {FilterEnum} from 'Agent/Accounts/ducks/account';

export const getSourceOptions = (isViewingNewYorkData: boolean): FilterEnum[] =>
  isViewingNewYorkData
    ? [
        {
          name: 'New York',
          value: '2',
        },
      ]
    : [
        {
          name: 'Ordinary',
          value: '3',
        },
        {
          name: 'Group',
          value: '1',
        },
      ];
